import { gql } from '@/__generated__';

const ALERT_STATE_FRAGMENT = gql(`#graphql
  fragment UpdateAlertStateFragment on AlertConfigurationByState {
    metricUnit
    comparisonType
    thresholdMin
    thresholdMax
    thresholdValue
    notificationDelaySec
  }
`);


const UPDATE_ALERT_CONFIGURATION = gql(`#graphql
  mutation UpdateAlertConfig($input: UpdateAlertConfigurationInput!) {
    updateAlertConfiguration(input: $input) {
      id
      rawData
      basicConfigurations {
        id
        flow {
          id
        }
        level {
          id
        }
        lastFlow {
          max
          min
          overflow
          id
        }
        lastLevel {
          max
          min
          overflow
          id
        }
      }
      configs: activeConfigurations {
        id
        metric
        ok {
          ...UpdateAlertStateFragment
        }
        info {
          ...UpdateAlertStateFragment
        }
        warning {
          ...UpdateAlertStateFragment
        }
        critical {
          ...UpdateAlertStateFragment
        }
      }
    }
  }
`);

export { UPDATE_ALERT_CONFIGURATION };
